import "./styles.js";

import "@fortawesome/fontawesome-free/js/all";

import React, { useState } from "react";
import { createRoot } from "react-dom/client";
// import { IntlProvider } from "react-intl";
// port messages from "~/locales/messages";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import LoginPage from "../bundles/devise/components/LoginPage.jsx";
// import RecoverPage from "bundles/devise/components/RecoverPage.jsx";
// import NewPasswordPage from "bundles/devise/components/NewPasswordPage.jsx";
// import RegisterPage from "bundles/devise/components/RegisterPage.jsx";
// import ConfirmPage from "bundles/devise/components/ConfirmPage.jsx";
// import UnlockPage from "bundles/devise/components/UnlockPage.jsx";
// import TermsConditions from "../components/TermsConditions";
// import FailedConfirmPage from "../bundles/devise/components/FailedConfirmPage";

import { ToastContainer, Zoom } from "react-toastify";
import RegisterPage from "../bundles/devise/components/RegisterPage.jsx";
import PasswordRecovery from "../bundles/devise/components/PasswordRecovery.jsx";
import PasswordChange from "../bundles/devise/components/PasswordChange.jsx";
import UnlockPage from "../bundles/devise/components/UnlockPage.jsx";

// let locale = "pt-PT";

// locale = locale.startsWith("en") ? "en" : locale;
// locale = messages[locale] ? locale : "pt-PT";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleCheckBox = (e) => {
    e.preventDefault();
    setAcceptedTerms((x) => !x);
  };

  const toggleTerms = (e) => {
    e.preventDefault();
    setIsOpen((x) => !x);
  };

  const acceptTerms = (e) => {
    e.preventDefault();
    setIsOpen(false);
    setAcceptedTerms(true);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        transition={Zoom}
      />

      <Switch>
        <Redirect
          exact
          from="/"
          to="/users/sign_in"
        />

        <Route
          path="/users/sign_in"
          render={() => <LoginPage />}
        />

        <Route
          path="/users/sign_up"
          render={() => <RegisterPage />}
        />

        <Route
          path="/users/password/new"
          render={() => <PasswordRecovery />}
        />

        <Route
          path="/users/password/edit"
          render={() => <PasswordChange />}
        />

        <Route
          path="/users/unlock/new"
          render={() => <UnlockPage />}
        />

        {/* <Route
          path="/users/sign_up"
          render={() => (
            <RegisterPage
              toggleTerms={toggleTerms}
              handleCheckBox={handleCheckBox}
              acceptTerms={acceptTerms}
              acceptedTerms={acceptedTerms}
            />
          )}
        />

        <Route
          path="/users/password/new"
          render={() => <RecoverPage />}
        />

        

        <Route
          path="/users/confirmation/new"
          render={() => <FailedConfirmPage />}
        />

        <Route
          path="/users/confirmation"
          render={() => <ConfirmPage />}
        />

        <Route
          path="/users/unlock"
          render={() => <UnlockPage />}
        /> */}
      </Switch>

      {/* {isOpen && (
        <TermsConditions
          closeTerms={toggleTerms}
          acceptTerms={acceptTerms}
        />
      )} */}
    </>
  );
};

const container = document.getElementById("container");

const root = createRoot(container);

root.render(
  <Router>
    <App />
  </Router>
);
